let ctx;
let unlocked = false;
/* 浏览器要求先有用户手势才能出声；手势前不创建 AudioContext，避免控制台刷警告 */
const activated = () => unlocked || !!navigator.userActivation?.hasBeenActive;
if (typeof window !== "undefined") {
  const unlock = () => { unlocked = true; try { ctx?.state === "suspended" && ctx.resume?.(); } catch { /* ignore */ } };
  ["pointerdown", "keydown", "touchstart"].forEach((ev) => window.addEventListener(ev, unlock, { capture: true, passive: true }));
}
const getCtx = () => {
  if (!activated()) return null;
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
};

/* 扫码反馈：成功短高音 / 失败长低音 + 手机振动 */
export const beep = (ok = true) => {
  try {
    ctx = getCtx();
    if (!ctx) throw new Error("no gesture");
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "square";
    o.frequency.value = ok ? 1500 : 320;
    g.gain.value = 0.06;
    o.connect(g);
    g.connect(ctx.destination);
    const t = ctx.currentTime;
    o.start(t);
    o.stop(t + (ok ? 0.09 : 0.28));
  } catch { /* no audio */ }
  try { navigator.vibrate?.(ok ? 40 : [90, 60, 90]); } catch { /* ignore */ }
};

/* 提醒到达：柔和双音（正弦，880→1320Hz） */
export const chime = () => {
  try {
    ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume?.();
    const t0 = ctx.currentTime;
    [[880, 0], [1320, 0.13]].forEach(([f, dt]) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t0 + dt);
      g.gain.exponentialRampToValueAtTime(0.06, t0 + dt + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dt + 0.28);
      o.connect(g); g.connect(ctx.destination);
      o.start(t0 + dt); o.stop(t0 + dt + 0.3);
    });
  } catch { /* no audio */ }
};
